import { render, staticRenderFns } from "./requestDetails.vue?vue&type=template&id=3f0f7a08&scoped=true"
import script from "./requestDetails.vue?vue&type=script&lang=js"
export * from "./requestDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0f7a08",
  null
  
)

export default component.exports